import { useTranslation } from '@/hooks/useTranslation';
import { Modal } from './Modal';
import { DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { useModalContext } from '@/hooks/useModalContext';
import mdxComponents from "@/components/mdx-components";
import { useGetDocs } from '@/hooks/useGetDocs';
import { MDXContent } from '@content-collections/mdx/react';

export const ShowVBMQuickstart = () => {
  const { t } = useTranslation('common');
  const { closeModal } = useModalContext();
  const docsContent = useGetDocs("(get-started)/quickstart");

  const handleClose = () => {
    closeModal('showVbmQuickstart');
  };

  return (
    <Modal modalType="showVbmQuickstart" title={t('quickstart')} className="lg:max-w-3xl">
      <div className="max-w-full space-y-4 prose dark:prose-invert">
        {
          docsContent ? (
            <MDXContent
                code={docsContent.mdx}
                components={mdxComponents}
              />
            ) : <>
              <p>{t('noContent')}</p>
            </>
          }

        <DialogFooter className="mt-4">
          <Button variant="ghost" onClick={handleClose}>
            {t('close')}
          </Button>
        </DialogFooter>
      </div>
    </Modal>
  );
};
